import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackLead } from "@/lib/analytics";
import type { Division } from "@/lib/leadGuard";
import type { Qualification } from "@/lib/leadSubmit";

export type LeadFormId =
  | "contacto"
  | "automatizar"
  | "visita"
  | "partner"
  | "dosier-retail"
  | "dosier-industrial"
  | "medical"
  | "estudio-implantacion"
  | "calculadora";

const DEFAULT_DIVISION: Record<LeadFormId, Division> = {
  contacto: "retail",
  automatizar: "retail",
  visita: "retail",
  partner: "retail",
  "dosier-retail": "retail",
  "dosier-industrial": "industrial",
  medical: "medical",
  "estudio-implantacion": "retail",
  calculadora: "retail",
};

export type ThanksState = { dossierUrl?: string; slot?: string };

export type LeadSuccessOpts = Qualification & {
  division?: Division;
  /** Spam: show the thank-you page but send no conversion. */
  spam?: boolean;
};

/** After a successful form submission: send the lead event and open the thank-you page. */
export const useLeadSuccess = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return useCallback(
    (form: LeadFormId, state?: ThanksState, opts: LeadSuccessOpts = {}) => {
      const lang = (i18n.language || "es").substring(0, 2);
      if (!opts.spam) {
        trackLead({
          form,
          division: opts.division ?? DEFAULT_DIVISION[form],
          lang,
          tipo_espacio: opts.tipo_espacio,
          num_ubicaciones: opts.num_ubicaciones,
          plazo: opts.plazo,
          request_type: opts.request_type,
        });
      }
      navigate(`/${lang}/gracias/${form}`, { state });
    },
    [i18n.language, navigate],
  );
};
